module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fII9c"))).then(() => parcelRequire('ln8lv'));